<template>
  <div id="gen-app" style="margin-top: 5%">
    <el-container>
      <el-header>生成授权信息</el-header>
      <el-container>
        <el-aside width="30%"></el-aside>
        <el-main>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="授权功能" prop="feature_name">
              <el-select
                v-model="ruleForm.feature_name"
                placeholder="请选择功能"
              >
                <el-option
                  v-for="item in featureItems"
                  :label="item.label"
                  :value="item.value"
                  :key="item.value"
                >
                  <span style="float: left">{{ item.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    item.code
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="授权模式" prop="license_mode">
              <el-select
                v-model="ruleForm.license_mode"
                placeholder="请选择授权模式"
                @change="selectAuthorize"
              >
                <el-option
                  v-for="item in licenseModes"
                  :label="item.label"
                  :value="item.value"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="授权时长"
              prop="expired_date"
              v-show="showExpiration"
            >
              <el-input
                v-model.number="ruleForm.expired_date"
                style="width: 220px;background-color: #fff;"
                :disabled="isDisabledDate"
              >
                <el-select
                  v-model="ruleForm.dateValue"
                  slot="prepend"
                  style="width: 100px;"
                  @change="selectDate"
                >
                  <el-option
                    v-for="item in timeUnits"
                    :label="item.label"
                    :value="item.value"
                    :key="item.value"
                  ></el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item label="总使用量" prop="used" v-show="showUsed">
              <el-input
                v-model.number="ruleForm.used"
                style="width: 220px;background-color: #fff;"
                :disabled="isDisabled"
              >
                <el-select
                  v-model="ruleForm.unit"
                  slot="prepend"
                  style="width: 100px;"
                  @change="selectUnit"
                >
                  <el-option
                    v-for="item in capacityUnits"
                    :label="item.label"
                    :value="item.value"
                    :key="item.value"
                  ></el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item label="系统版本" prop="systemVersion">
              <el-select
                v-model="ruleForm.systemVersion"
                placeholder="请选择系统版本"
              >
                <el-option
                  v-for="item in versionList"
                  :label="item.label"
                  :value="item.value"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="批量授权" prop="is_batch">
              <el-switch
                v-model="ruleForm.is_batch"
                active-color="#13ce66"
              ></el-switch>
            </el-form-item>
            <el-form-item
              label="授权数量"
              prop="batch_num"
              v-show="ruleForm.is_batch"
            >
              <el-input
                v-model="ruleForm.batch_num"
                placeholder="请输入批量授权数量"
                style="width: 220px"
              ></el-input>
            </el-form-item>
            <el-form-item label="申请人" prop="applicant" v-show="ruleForm">
              <el-input
                v-model="ruleForm.applicant"
                placeholder="请输入申请人"
                style="width: 220px"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="目标客户"
              prop="target_customer"
              v-show="ruleForm"
            >
              <el-input
                v-model="ruleForm.target_customer"
                placeholder="请输入目标客户"
                style="width: 220px"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')"
                >立即创建</el-button
              >
              <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="success" @click="downLicFile" v-show="showDown"
                >下载预授权文件</el-button
              >
            </el-form-item>
          </el-form>
        </el-main>
        <el-aside width="30%"></el-aside>
      </el-container>
    </el-container>
    <ConfirmationDialog
      ref="ConfirmationDialog"
      :descriptions-items="postItem"
      @sendResult="sendResult"
    />
  </div>
</template>
<style></style>
<script>
import axios from "axios";
import ConfirmationDialog from "@/components/ConfirmationDialog";

export default {
  name: "GenerateForm",
  components: {
    ConfirmationDialog,
  },
  data() {
    return {
      ruleForm: {
        feature_name: "",
        license_mode: "",
        expired_date: "", // 授权时长
        capacity: "",
        is_batch: false,
        batch_num: 1,
        systemVersion: "",
        used: "",
        unit: "1", // 使用量单位默认值
        dateValue: "", // 时间单位默认值
        applicant: "", //申请人
        target_customer: "", //目标客户
      },
      rules: {
        feature_name: [
          { required: true, message: "请选择功能代码", trigger: "change" },
        ],
        license_mode: [
          { required: true, message: "请选择授权模式", trigger: "change" },
        ],
        systemVersion: [
          { required: true, message: "请选择系统版本", trigger: "change" },
        ],
        expired_date: [
          {
            required: true,
            message: "请输入时长",
            trigger: ["blur", "change"],
          },
          {
            type: "number",
            message: "使用量必须为数字值",
            trigger: ["blur", "change"],
          },
        ],
        used: [
          { required: true, message: "请填写总使用量", trigger: "blur" },
          { type: "number", message: "使用量必须为数字值", trigger: "blur" },
        ],
      },
      showUsed: false,
      showExpiration: false,
      isDisabled: false,
      isDisabledDate: false,
      rules2: {
        expired_date: [
          { required: true, message: "请输入时长", trigger: "blur" },
          { type: "number", message: "使用量必须为数字值", trigger: "blur" },
        ],
        used: [
          { required: true, message: "请填写总使用量", trigger: "blur" },
          { type: "number", message: "使用量必须为数字值", trigger: "blur" },
        ],
      },
      // 系统代码
      featureItems: [
        {
          value: "Aidlux",
          label: "Aidlux系统授权",
          code: "000001",
        },
        {
          value: "AICreatorDeploy",
          label: "AI Creator生成模型无限制部署授权",
          code: "010001",
        },
      ],
      // 授权类型
      licenseModes: [
        {
          value: "1",
          label: "时间",
        },
        {
          value: "2",
          label: "用量",
        },
      ],
      // 系统版本
      versionList: [
        {
          value: "0.1",
          label: "正式版本",
        },
        // {
        //   value: "0.2",
        //   label: "B版本"
        // }
      ],
      // 使用天数容量单位
      timeUnits: [
        {
          value: "",
          label: "自定义",
          isOptional: true, // 可选
        },
        {
          value: "30",
          label: "一个月",
          isOptional: false, // 不可选
        },
        {
          value: "90",
          label: "三个月",
          isOptional: false, // 不可选
        },
        {
          value: "180",
          label: "半年",
          isOptional: false, // 不可选
        },
        {
          value: "365",
          label: "一年",
          isOptional: false, // 不可选
        },
        {
          value: "-1",
          label: "无限",
          isOptional: false, // 不可选
        },
      ],
      // 使用量容量单位
      capacityUnits: [
        {
          value: "1",
          label: "每日",
          unitString: "D",
        },
        {
          value: "2",
          label: "每周",
          unitString: "W",
        },
        {
          value: "-1",
          label: "无限",
          unitString: undefined,
        },
      ],
      postItem: {
        postData: {},
        showData: [],
      },
      licFileId: null,
      showDown: false,
    };
  },
  methods: {
    copyValue(value) {
      if (!value) {
        return;
      }
      let oInput = document.createElement("input"); //创建一个input标签
      oInput.setAttribute("value", value); // 设置改input的value值
      document.body.appendChild(oInput); // 将input添加到body
      oInput.select(); // 获取input的文本内容
      document.execCommand("copy"); // 执行copy指令
      document.body.removeChild(oInput); // 删除input标签
      this.$message({ message: "复制成功", type: "success" });
    },
    sendResult: function(licFileId) {
      this.licFileId = licFileId;
      this.showDown = true;
    },
    downLicFile() {
      if (this.licFileId) {
        location.href =
          location.origin + "/api/license/pre_lic/" + this.licFileId;
      } else {
        this.$message.error("预授权文件不存在");
      }
    },
    submitForm(formName) {
      const that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.processData().then(
            function(response) {
              if (!response) {
                that.$message.error("数据处理错误");
                return false;
              }
              that.$refs.ConfirmationDialog.confirmationShow();
            },
            function(e) {
              alert(e);
              that.$message.error("数据错误");
            }
          );
        } else {
          that.$message.error("接口请求失败,请检查输入是否正确");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 处理数据
    async processData() {
      const featureElement = this.findElementByValue(
        this.featureItems,
        this.ruleForm.feature_name
      );
      this.postItem.postData = {
        feature_code: featureElement.code,
        feature_name: featureElement.value,
        license_mode: this.ruleForm.license_mode,
        // user_type: this.ruleForm.user_type
        version: this.ruleForm.systemVersion,
        applicant: this.ruleForm.applicant,
        target_customer: this.ruleForm.target_customer,
      };

      const showData = [
        { label: "授权功能", value: this.postItem.postData.feature_name },
        { label: "授权代码", value: this.postItem.postData.feature_code },
        {
          label: "授权模式",
          value: this.findElementByValue(
            this.licenseModes,
            this.ruleForm.license_mode
          ).label,
        },
        // {label: '用户类型', value: this.findElementByValue(this.userTypes, this.ruleForm.user_type).label},
      ];
      if (this.ruleForm.is_batch) {
        this.postItem.postData.is_batch = this.ruleForm.is_batch;
        this.postItem.postData.batch_num = this.ruleForm.batch_num;
        showData.push({ label: "批量授权", value: this.ruleForm.is_batch });
        showData.push({ label: "授权数量", value: this.ruleForm.batch_num });
      }
      // 时间授权
      if (this.ruleForm.license_mode.toString() === "1") {
        // const expiredDate = this.dateFormat('YYYYmmdd', this.ruleForm.expired_date)
        const expiredDate = this.ruleForm.expired_date.toString();
        this.postItem.postData.duration = expiredDate;
        showData.push({ label: "授权时长(天)", value: expiredDate });
      }
      // 用量授权
      else if (this.ruleForm.license_mode.toString() === "2") {
        let usedString;
        let showItem = { label: "总使用量", value: "" };
        // todo 多种类型
        if (Number(this.ruleForm.unit) === 1) {
          // 天
          usedString = "D" + this.ruleForm.used.toString();
          showItem.value = this.ruleForm.used.toString() + "/天";
        } else if (Number(this.ruleForm.unit) === 2) {
          // 周
          usedString = "W" + this.ruleForm.used.toString();
          showItem.value = this.ruleForm.used.toString() + "/周";
        } else if (this.ruleForm.unit.toString() === "-1") {
          // 无限
          usedString = "-1";
          showItem.value = "无限次";
        } else {
          this.$message.error("无效的日期单位");
          return false;
        }
        this.postItem.postData.capacity = usedString;
        showData.push(showItem);
      } else {
        return false;
      }
      this.postItem.showData = showData;
      return true;
    },
    selectDate(event) {
      const timeElement = this.findElementByValue(this.timeUnits, event);
      if (timeElement.isOptional) {
        this.isDisabledDate = false;
      } else {
        this.ruleForm.expired_date = Number(timeElement.value);
        this.isDisabledDate = true;
      }
      this.$refs.ruleForm.validateField('expired_date')
    },
    selectUnit(event) {
      if (Number(event) === -1) {
        this.isDisabled = true;
        this.ruleForm.used = 0;
      } else {
        this.isDisabled = false;
      }
    },
    selectAuthorize(event) {
      if (event === "1") {
        this.showUsed = false;
        this.showExpiration = true;
        this.rules.expired_date = this.rules2.expired_date;
        this.rules.used = [];
        this.ruleForm.used = "";
      } else if (event === "2") {
        this.showUsed = true;
        this.showExpiration = false;
        this.rules.expired_date = [];
        this.rules.used = this.rules2.used;
        this.ruleForm.expired_date = "";
      }
    },
    findElementByValue(dataObject, value) {
      for (const i of dataObject) {
        if (i.value === value) {
          return i;
        }
      }
    },
    getInit() {
      axios.get("/api/license/feature/list").then((response) => {
        this.featureItems = response.data;
      });
    },
  },
  created() {
    this.getInit();
  },
};
</script>
